<template>
  <div class="ccc">
    <TopHead></TopHead>
    <logoNav></logoNav>
    <div class="uc_con">
      <div class="uc_title d_f ali_c flex_1">
        <div class="uc_green"></div>
        <div>订单查询</div>
      </div>

      <el-form :inline="true" :model="pageInfo.data" class="demo-form-inline">
        <el-form-item label="订单号"  label-width="100px">
          <el-input placeholder="订单号" v-model="pageInfo.data.orderNumber"></el-input>
        </el-form-item>
        <el-form-item label="订单状态" label-width="100px">
          <el-select placeholder="订单状态" v-model="pageInfo.data.orderStatus">
            <el-option v-for="(item,index) in staArr" :key='index' :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预订消费日期" label-width="100px">
          <el-date-picker
            v-model="value1"
            type="daterange"
            value-format="YYYY-MM-DD"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="预订人姓名" label-width="100px">
          <el-input placeholder="预订人姓名" v-model="pageInfo.data.reservationPersonName"></el-input>
        </el-form-item>
        <el-form-item label="预订人电话" label-width="100px">
          <el-input placeholder="预订人电话" v-model="pageInfo.data.reservationPersonTelephone"></el-input>
        </el-form-item>
        <el-form-item label="支付方式" label-width="100px">
          <el-select placeholder="支付方式" v-model="pageInfo.data.payTypeId">
            <el-option v-for="(item,index) in payArr" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单创建时间" label-width="100px">
          <el-date-picker
            v-model="value2"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="YYYY-MM-DD"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetSearch()">重置</el-button>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="uc_con">
      <div class="uc_title d_f ali_c flex_1">
        <div class="uc_green"></div>
        <div>订单列表</div>
      </div>

      <el-table
        ref="multipleTable"
        :data="list"
        stripe
        :header-cell-style="{'text-align':'center','background-color': '#F4F4F4','font-size': '14px','color': '#333','font-weight': 'bold'}"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column label="订单号" align="center">
          <template #default="scope">
            <span class="cur_p t_num" @click="goDetail(scope.row)">{{scope.row.orderNumber}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="订单状态" align="center">
          <template #default="scope">
            <span>{{scope.row.orderStatus ? staArr[scope.row.orderStatus].name : '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalPurchaseNumber" label="总票数" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="totalSellPrice" label="总金额" align="center" show-overflow-tooltip>
          <template #default="scope">
            <span>{{scope.row.totalSellPrice ? Number(scope.row.totalSellPrice/100).toFixed(2) : 0}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bookUseDate" label="预订消费日期" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="reservationPersonName" label="预订人姓名" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="reservationPersonTelephone" label="预订人电话" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="payTypeId" label="支付方式" align="center" show-overflow-tooltip>
          <template #default="scope">
            <span>{{getPayType(scope.row.payTypeId )}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="payNumber" label="支付单号" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creatorTime" label="订单创建时间" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" align="center" width="250">
          <template #default="scope">
            <div class="d_f ali_c j_c">
              <div class="right_btn cur_p" @click="orderRefundRow(scope.row)" v-if="scope.row.orderStatus == 5">
                <img src="../assets/images/o_tk.png" alt="">
                <span>退款</span>
              </div>
              <div class="right_btn cur_p ml_5" @click="payRow(scope.row)" v-if="scope.row.orderStatus<2">
                <img src="../assets/images/tr_zhifu.png" alt="">
                <span>支付</span>
              </div>
              <div class="right_btn big cur_p ml_5" @click="refundDetail(scope.row)" v-if="scope.row.isRefund == 1">
                <img src="../assets/images/o_tk.png" alt="">
                <span>退款详情</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="t_r mt_12">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          v-model:currentPage="pageInfo.pageIndex"
          :page-sizes="$global.pageArr"
          :page-size="pageInfo.pageSize"
          layout="sizes, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "order",
    data() {
      return {
        value1:'',
        value2:'',
        staArr:[
          {value:0,name:'未支付'},
          {value:1,name:'待支付'},
          {value:2,name:'已取消'},
          {value:3,name:'订单关闭'},
          {value:4,name:'出票失败'},
          {value:5,name:'出票成功'},
        ],
        payArr:[],
        list:[],
        total:1,
        pageInfo:{
          pageIndex:1,
          pageSize:10,
          data:{
            orderNumber:'',
            orderStatus:'',
            startDate:'',
            endDate:'',
            createStartDate:'',
            createEndDate:'',
            reservationPersonName:'',
            reservationPersonTelephone:'',
            payTypeId:'',
          }
        }
      }
    },
    created() {
      this.queryDisPayType();
      this.search();
    },
    methods: {
      search(){
        if(this.value1){
          this.pageInfo.data.startDate = this.value1[0];
          this.pageInfo.data.endDate = this.value1[1];
        }
        if(this.value2){
          this.pageInfo.data.createStartDate = this.value2[0];
          this.pageInfo.data.createEndDate = this.value2[1];
        }
        this.$api.queryOrderList(this.pageInfo).then(res => {
          this.total = res.data.recordCount;
          this.list = res.data.rows;
        })
      },
      resetSearch(){
        this.value1 = '';
        this.value2 = '';
        this.pageInfo.data = {
          orderNumber:'',
          orderStatus:'',
          startDate:'',
          endDate:'',
          createStartDate:'',
          createEndDate:'',
          reservationPersonName:'',
          reservationPersonTelephone:'',
          payTypeId:'',
        };
        this.search();
      },
      getPayType(id){
        let str ='';
        this.payArr.map(item => {
          if(id == item.value){
            str = item.name
          }
        });
        return str
      },
      handleSizeChange(val) {
        this.pageInfo.pageSize = val;
        this.pageInfo.pageIndex = 1;
        this.search();
      },
      handleCurrentChange(val) {
        this.pageInfo.pageIndex = val;
        this.search();
      },
      //跳转退款
      orderRefundRow(row){
        this.$router.push({path:'/orderRefund',query:{orderId:row.orderId,orderNumber:row.orderNumber}});
      },
      //跳转退款详情
      refundDetail(row){
        this.$router.push({path:'/refundDetail',query:{orderId:row.orderId,orderNumber:row.orderNumber}});
      },
      //跳转支付
      payRow(row){
        this.$router.push({path:'/pay',query:{id:row.orderId,num:row.orderNumber}});
      },
      //支付方式
      queryDisPayType(){
        this.$api.queryDisPayType().then(res => {
          this.payArr = res.data;
        })
      },
      //跳转详情
      goDetail(row){
        this.$router.push('/orderDetails?orderId='+row.orderId+'&num='+row.orderNumber)
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
